let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("JJCFM")).then(() => parcelRequire('eI0S6'));